import { render, staticRenderFns } from "./DniForm.vue?vue&type=template&id=e2a1ff78&scoped=true&"
import script from "./DniForm.vue?vue&type=script&lang=js&"
export * from "./DniForm.vue?vue&type=script&lang=js&"
import style0 from "./DniForm.vue?vue&type=style&index=0&id=e2a1ff78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a1ff78",
  null
  
)

export default component.exports